import { ROLES } from '@/lib/authorization';
import { useNavigate } from 'react-router-dom';

import { Layout } from '../components/Layout';
import { LoginForm } from '../components/LoginForm';

export const LoginLawyer = () => {
  const navigate = useNavigate();
  return (
    <Layout title="Log in to your account">
      <LoginForm
        type={ROLES.LAWYER}
        onSuccess={(url) => {
          navigate(url);
        }}
      />
    </Layout>
  );
};
